import { createGlobalStyle } from 'styled-components';

export const Styles = createGlobalStyle`
@import url('https://fonts.googleapis.com/css2?family=Catamaran:wght@400;900&display=swap');

    @font-face {
        font-family: 'Catamaran';
        src: url("/fonts/Catamaran-Regular.ttf") format("truetype");
        font-style: normal;
    }
    @font-face {
        font-family: 'nabana';
        src: url("/fonts/nabana.shadow-bold.ttf") format("truetype");
        font-style: normal;
    }
    @font-face {
        font-family: 'LuckiestGuy';
        src: url("/fonts/LuckiestGuy-Regular.ttf") format("truetype");
        font-style: normal;
    }

    @font-face {
        font-family: 'Catamaran';
        src: url("/fonts/Catamaran-ExtraBold.ttf") format("truetype");
        font-style: normal;
    }
    body,
    html,
    a {
        font-family: 'Catamaran', sans-serif;
        color: #fff;
    }


    body {
        margin:0;
        padding:0;
        border: 0;
        outline: 0;
        background: #161616;
        overflow-x: hidden;
    }

    a:hover {
        color: #fff;
    }

    input,
    textarea {
        border-radius: 4px;
        border: 0;
        background: rgb(241, 242, 243);
        transition: all 0.3s ease-in-out;  
        outline: none;
        width: 100%;  
        padding: 1rem 1.25rem;

        :focus-within {
            background: none;
            box-shadow: #2e186a 0px 0px 0px 1px;
        }
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-family: 'Catamaran', sans-serif;
        color: #fff !important;
        font-size: 70px;
        line-height: 1.18;

        font-weight: 800;

        @media only screen and (max-width: 890px) {
          font-size: 47px;
        }
      
        @media only screen and (max-width: 414px) {
          font-size: 32px;
        }

        text-shadow: #000000 0px 0px 2px,   #000000 0px 0px 2px,   #000000 0px 0px 2px,
        #000000 0px 0px 2px,   #000000 0px 0px 2px,   #000000 0px 0px 2px,
        4px 4px #000000;
    }

    p {
        color: #fff;
        font-size: 21px;        
        line-height: 1.41;
    }

    h1 {
        font-weight: 600;
    }

    a {
        text-decoration: none;
        outline: none;
        color: #2E186A;

        :hover {
            color: #2e186a;
        }
    }
    
    *:focus {
        outline: none;
    }

    .about-block-image svg {
        text-align: center;
    }

    .ant-drawer-body {
        display: flex;
        flex-direction: column;
        text-align: left;
        padding-top: 1.5rem;
    }

    .ant-drawer-content-wrapper {
        width: 300px !important;
    }
`;
